import { useFormContext } from '@/lib/form.ts';
import { useStore } from '@tanstack/react-form';
import { Alert, AlertDescription } from '@/common/components/ui/alert';
import { cn } from '@/lib/utils';
import { CircleAlert } from 'lucide-react';

interface FormErrorsProps {
  className?: string;
}

export const FormErrors = ({ className }: FormErrorsProps) => {
  const form = useFormContext();
  const allErrors = useStore(form.store, (state) => state.errors);
  const formErrors = allErrors.filter((item) => 'form' in item).map((item) => item.form);

  return formErrors.length === 0 ? null : (
    <div className={cn('flex flex-col gap-2', className)}>
      {formErrors.map((error) => (
        <Alert key={error} variant="destructive" className="border-destructive/40 bg-destructive/8">
          <CircleAlert />
          <AlertDescription className="text-destructive">{error}</AlertDescription>
        </Alert>
      ))}
    </div>
  );
};
